<template>
  <v-container fluid class="pa-4 bg-light">
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center mb-6 pl-2">
          <v-avatar color="primary" size="50" class="mr-4 elevation-3">
            <v-icon dark size="28">mdi-filmstrip</v-icon>
          </v-avatar>
          <div class="d-flex flex-grow-1 align-center justify-space-between">
            <div>
              <h2 class="text-h4 font-weight-black primary--text mb-0 letter-spacing-tight">Recursos Multimedia</h2>
              <div class="text-subtitle-1 grey--text text--darken-1 font-weight-medium">Gestión y Validación de Videos</div>
            </div>
            
            <!-- Selector de Instancia -->
            <v-select
              v-if="mostrarSelector"
              v-model="escuelaSel"
              :items="escuelas"
              item-text="nombre"
              item-value="id"
              label="Cambiar Instancia"
              outlined
              dense
              hide-details
              color="primary"
              style="max-width: 250px"
              class="elevation-1 bg-white rounded-lg select-instancia"
              prepend-inner-icon="mdi-domain"
            ></v-select>
          </div>
        </div>
        
        <v-card class="mb-6 rounded-lg main-tabs-card" elevation="1">
          <v-tabs 
            v-model="tab" 
            background-color="white" 
            color="primary" 
            active-class="active-tab"
            height="56"
            centered
            grow
          >
            <v-tabs-slider color="primary" class="tab-slider"></v-tabs-slider>
            
            <v-tab class="font-weight-bold text-subtitle-2 text-capitalize">
              <v-icon left size="20">mdi-inbox-arrow-down</v-icon> Recepción de Videos
            </v-tab>
            <v-tab v-if="puedeValidar" class="font-weight-bold text-subtitle-2 text-capitalize">
              <v-icon left size="20">mdi-check-decagram</v-icon> Validación (Merca)
            </v-tab>
            <v-tab class="font-weight-bold text-subtitle-2 text-capitalize">
              <v-icon left size="20">mdi-chart-areaspline</v-icon> Estadísticas
            </v-tab>
          </v-tabs>
        </v-card>

        <v-tabs-items v-model="tab" style="background-color: transparent;" class="fade-transition">
          <v-tab-item class="pb-6">
            <VideosRecepcion ref="tab0" :escuelaProp="escuelaSel" />
          </v-tab-item>
          
          <v-tab-item v-if="puedeValidar" class="pb-6">
            <ValidacionVideosMerca ref="tab1" :escuelaProp="escuelaSel" />
          </v-tab-item>
          
          <v-tab-item class="pb-6">
            <EstadisticasVideosMerca :ref="puedeValidar ? 'tab2' : 'tab1'" :escuelaProp="escuelaSel" />
          </v-tab-item>
        </v-tabs-items>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VideosRecepcion from '@/views/marketing/VideosRecepcion.vue';
import ValidacionVideosMerca from '@/views/marketing/ValidacionVideosMerca.vue';
import EstadisticasVideosMerca from '@/views/marketing/EstadisticasVideosMerca.vue';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'PanelVideosMerca',
  components: {
    VideosRecepcion,
    ValidacionVideosMerca,
    EstadisticasVideosMerca
  },
  data() {
    return {
      tab: null,
      escuelaSel: 1, // Por defecto se inicializará con la escuela del usuario
      escuelas: [
        { id: 1, nombre: 'INBI' },
        { id: 2, nombre: 'FAST' }
      ]
    };
  },
  computed: {
    ...mapState('login', ['datosUsuarioERP']),
    ...mapGetters('login', ['getEscuela']),
    puedeValidar() {
      // 97, 25, 48, 74 (Mercadotecnia) y 12 (Dev)
      const allowedRoles = [97, 25, 48, 74, 12, 11, 43, 74, 97, 101, 25 ];
      if (!this.datosUsuarioERP || !this.datosUsuarioERP.idpuesto) return false;
      return allowedRoles.includes(Number(this.datosUsuarioERP.idpuesto));
    },
    mostrarSelector() {
      // 12, 40, 48, 113
      const rolesConSelector = [12, 40, 48, 113, 11, 43, 74, 97, 101, 25  ];
      if (!this.datosUsuarioERP || !this.datosUsuarioERP.idpuesto) return false;
      return rolesConSelector.includes(Number(this.datosUsuarioERP.idpuesto));
    }
  },
  watch: {
    tab(newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.$nextTick(() => {
          const tabRefName = 'tab' + newVal;
          if (this.$refs[tabRefName]) {
            // Evaluamos si el componente está directamente o si hay que acceder a un subcomponente/array
            const comp = Array.isArray(this.$refs[tabRefName]) ? this.$refs[tabRefName][0] : this.$refs[tabRefName];
            if (comp && typeof comp.initialize === 'function') {
              comp.initialize();
            }
          }
        });
      }
    }
  },
  created() {
    if (this.getEscuela) {
      this.escuelaSel = this.getEscuela;
    }
  }
};
</script>

<style scoped>
.bg-light {
  background-color: #f8faff;
  min-height: calc(100vh - 64px);
}

.shadow-primary {
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.4) !important;
}

.letter-spacing-tight {
  letter-spacing: -0.5px;
}

.main-tabs-card {
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.active-tab {
  color: #1976d2 !important;
  background-color: #f5f9ff;
}

.tab-slider {
  height: 3px;
}

.transition-fast {
  transition: all 0.2s ease;
}

.fade-transition-enter-active, .fade-transition-leave-active {
  transition: opacity 0.3s;
}
.fade-transition-enter, .fade-transition-leave-to {
  opacity: 0;
}

.select-instancia .v-input__control > .v-input__slot {
  background: white !important;
  box-shadow: none !important;
}
</style>
